import { render } from "./UltraHeader.vue?vue&type=template&id=e677fbc6&scoped=true"
import script from "./UltraHeader.vue?vue&type=script&lang=js"
export * from "./UltraHeader.vue?vue&type=script&lang=js"

import "./UltraHeader.vue?vue&type=style&index=0&id=e677fbc6&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/softline-infinity-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e677fbc6"]])

export default __exports__